/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { authControllerChangePassword } from '../fn/auth/auth-controller-change-password';
import { AuthControllerChangePassword$Params } from '../fn/auth/auth-controller-change-password';
import { authControllerForgotPassword } from '../fn/auth/auth-controller-forgot-password';
import { AuthControllerForgotPassword$Params } from '../fn/auth/auth-controller-forgot-password';
import { authControllerLogin } from '../fn/auth/auth-controller-login';
import { AuthControllerLogin$Params } from '../fn/auth/auth-controller-login';
import { authControllerMe } from '../fn/auth/auth-controller-me';
import { AuthControllerMe$Params } from '../fn/auth/auth-controller-me';
import { authControllerRegister } from '../fn/auth/auth-controller-register';
import { AuthControllerRegister$Params } from '../fn/auth/auth-controller-register';
import { AuthUserDto } from '../models/auth-user-dto';
import { SessionDto } from '../models/session-dto';

@Injectable({ providedIn: 'root' })
export class AuthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `authControllerMe()` */
  static readonly AuthControllerMePath = '/auth/me';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerMe()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerMe$Response(params?: AuthControllerMe$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthUserDto>> {
    return authControllerMe(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerMe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerMe(params?: AuthControllerMe$Params, context?: HttpContext): Observable<AuthUserDto> {
    return this.authControllerMe$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthUserDto>): AuthUserDto => r.body)
    );
  }

  /** Path part for operation `authControllerRegister()` */
  static readonly AuthControllerRegisterPath = '/auth/register';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerRegister()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerRegister$Response(params: AuthControllerRegister$Params, context?: HttpContext): Observable<StrictHttpResponse<SessionDto>> {
    return authControllerRegister(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerRegister$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerRegister(params: AuthControllerRegister$Params, context?: HttpContext): Observable<SessionDto> {
    return this.authControllerRegister$Response(params, context).pipe(
      map((r: StrictHttpResponse<SessionDto>): SessionDto => r.body)
    );
  }

  /** Path part for operation `authControllerLogin()` */
  static readonly AuthControllerLoginPath = '/auth/login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerLogin$Response(params: AuthControllerLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<SessionDto>> {
    return authControllerLogin(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerLogin(params: AuthControllerLogin$Params, context?: HttpContext): Observable<SessionDto> {
    return this.authControllerLogin$Response(params, context).pipe(
      map((r: StrictHttpResponse<SessionDto>): SessionDto => r.body)
    );
  }

  /** Path part for operation `authControllerForgotPassword()` */
  static readonly AuthControllerForgotPasswordPath = '/auth/forgot-password';

  /**
   * Not implemented.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerForgotPassword()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  authControllerForgotPassword$Response(params: AuthControllerForgotPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authControllerForgotPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * Not implemented.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerForgotPassword$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  authControllerForgotPassword(params: AuthControllerForgotPassword$Params, context?: HttpContext): Observable<void> {
    return this.authControllerForgotPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authControllerChangePassword()` */
  static readonly AuthControllerChangePasswordPath = '/auth/change-password';

  /**
   * Not implemented.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerChangePassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   *
   * @deprecated
   */
  authControllerChangePassword$Response(params: AuthControllerChangePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authControllerChangePassword(this.http, this.rootUrl, params, context);
  }

  /**
   * Not implemented.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerChangePassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   *
   * @deprecated
   */
  authControllerChangePassword(params: AuthControllerChangePassword$Params, context?: HttpContext): Observable<void> {
    return this.authControllerChangePassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
